import { render } from "./Fatca.vue?vue&type=template&id=1ccc533c"
import script from "./Fatca.vue?vue&type=script&lang=js"
export * from "./Fatca.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__